import MainButton from "../../../components/button/mainButton";
import HeaderBar from "../../../components/header/headerBar";
import { Icon } from "@iconify/react";
import { Table, TableColumn } from "../../../components/table";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Form, Modal, Input, Row, Col, Button, Space, Pagination } from "antd";
import "../../../assets/styles/admin/branchList.scss";
import axios from "axios";

const BranchesRoom = () => {
  interface ParamTypes {
    id: string;
  }

  const { id } = useParams<ParamTypes>();
  let [formModalBranch] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);
  const [roomBranch, setRoomBranch] = useState<string>("");
  const [amountRoomm, setAmountRoom] = useState<string>("");
  const [branchType, setBranchType] = useState<string>("");
  const [stateDatas, setStateDatas] = useState<any>([]);

  const [type, setType] = useState("");
  const [pages, setPages] = useState(1);
  const [countPages, setCountPages] = useState(1);
  const [idcate, setIdCate] = useState("");

  const { confirm } = Modal;

  function onClose() {
    setIsOpen(false);
  }

  const column = [
    {
      title: "",
    },
    {
      title: "Room Types",
      align: "center",
    },
    {
      title: "Quantity",
      align: "center",
    },
    {
      title: "Action",
      align: "center",
      colspan: 2,
    },
  ];

  const getData = async () => {
    axios.get(`/branch-rooms?branchId=${id}&page=${pages}`).then((res) => {
      // console.log("ressss", res.data.data);
      setStateDatas(res?.data?.data);
      // setAgencyType(res.data.data);
      setCountPages(res?.data?.pages);
      setPages(res?.data?.page);
    });
  };

  const createData = (value: any) => {
    // console.log("CREATE DATA !");
    const datas = {
      branch: id,
      name: value?.name,
      numberRooms: value?.numberRooms,
    };

    axios.post(`/branch-rooms`, datas).then((res) => {
      setTimeout(() => getData(), 200);
      setIsOpen(false);
    });
    formModalBranch.setFieldsValue({
      name: null,
      numberRooms: null,
    });
  };
  const getDataOne = (value: any) => {
    axios.get(`/branch-rooms/${value?._id}`).then((res) => {
      // console.log("resss", res?.data?.data);
      setIdCate(value?._id);
      formModalBranch.setFieldsValue({
        name: res?.data?.data?.name,
        numberRooms: res?.data?.data?.numberRooms,
      });
    });
  };
  const updateData = (value: any) => {
    // console.log("update", value);

    // console.log("UPDATE DATA !", idcate);
    axios
      .patch(`/branch-rooms/${idcate}`, {
        branch: id,
        name: value?.name,
        numberRooms: value?.numberRooms,
      })
      .then((res) => {
        setTimeout(() => getData(), 200);
        setIsOpen(false);
      });
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        deleteData(id);
      },
    });
  }

  const deleteData = (id: any) => {
    // console.log("update", value);

    // console.log("UPDATE DATA !", idcate);
    axios.delete(`/branch-rooms/${id}`).then((res) => {
      setTimeout(() => getData(), 200);
      setIsOpen(false);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const Onsubmit = (value: any) => {
    if (type === "CREATE") {
      createData(value);
    } else if (type === "UPDATE") {
      updateData(value);
    }
    // console.log("values", value);
  };
  const onchangePage = (e: any) => {
    setPages(pages);
    getData();
  };
  return (
    <>
      <HeaderBar title="BRANCHES / ROOM LIST" btnBack={true} />
      <div style={{ padding: "0px 40px" }}>
        <Modal visible={isOpen} footer={null} onCancel={() => setIsOpen(false)}>
          <Form form={formModalBranch} onFinish={Onsubmit} layout="vertical">
            <h4>{type} ROOM TYPE</h4>
            <Row className="formmodal-branches">
              <Col xs={18} sm={18} md={18} lg={18}>
                <Form.Item
                  label="Name Type"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Name Type!",
                    },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>

                <Form.Item
                  label="Quantity"
                  name="numberRooms"
                  rules={[
                    { required: true, message: "Please input your Quantity!" },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col>
            </Row>
            <Row className="buttonmodal-branch">
              <Col>
                <Space>
                  <Button
                    className="cancleButton-branch"
                    onClick={() => {
                      setIsOpen(false);
                      formModalBranch.resetFields();
                    }}
                  >
                    ยกเลิก/Cancel
                  </Button>
                  <Button
                    className="confirmButton-branch"
                    htmlType="submit"
                    onClick={() => {
                      // if (type === "update") {
                      //   update();
                      // }
                    }}
                  >
                    บันทึกข้อมูล/Submit
                  </Button>
                </Space>
              </Col>
            </Row>
          </Form>
        </Modal>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <MainButton
            title={"CREATE ROOM TYPE"}
            onClick={() => {
              setIsOpen(true);
              setType("CREATE");
              formModalBranch.resetFields();
            }}
          >
            <Icon
              icon="ant-design:plus-outlined"
              width="24"
              height="24"
              vFlip={true}
              color="#FFF"
            />
          </MainButton>
          {/* <div className="btn-new">สร้าง OPD ใหม่</div> */}
        </div>
        <div className="mt-20">
          <Table header={column}>
            {stateDatas.map((item: any, index: number) => (
              <tr
                key={index}
                // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                style={{ cursor: "pointer" }}
              >
                <TableColumn width="1%">{index + 1}</TableColumn>
                <TableColumn width="40%" align="center">
                  {item.name}
                </TableColumn>
                <TableColumn width="1%" align="center">
                  {item.numberRooms}
                </TableColumn>
                <TableColumn width="1%" align="center">
                  <div
                    onClick={() => {
                      getDataOne(item);
                      setIsOpen(true);
                      setType("UPDATE");
                    }}
                  >
                    <Icon
                      icon="el:pencil-alt"
                      rotate={3}
                      vFlip={true}
                      color="#5BAEA9"
                      width="20"
                      height="20"
                    />
                  </div>
                </TableColumn>
                <TableColumn width="1%" align="center">
                  <div onClick={() => showDeleteConfirm(item._id, item.name)}>
                    <Icon
                      icon="fa-solid:trash-alt"
                      width="20"
                      height="20"
                      color="#FF6760"
                    />
                  </div>
                </TableColumn>
              </tr>
            ))}
          </Table>
          <Row justify="end" className="pagination-agency">
            <Pagination
              defaultCurrent={pages}
              total={countPages}
              onChange={(e: any) => {
                onchangePage(e);
              }}
            />
          </Row>
        </div>
      </div>
    </>
  );
};
export default BranchesRoom;
